// React
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
// Styles
import useStyles from './CustomTooltip.styles'
import { Tooltip } from '@material-ui/core'

const CustomTooltip = ({ classes, isArrowShown, ...props }) => {
  const { arrow, popper, ...componentClasses } = useStyles()
  const [arrowRef, setArrowRef] = useState(null)
  return (
    <Tooltip
      classes={{
        popper: classNames(popper, classes.popper),
        ...componentClasses,
      }}
      PopperProps={{
        popperOptions: {
          modifiers: {
            arrow: {
              enabled: Boolean(arrowRef),
              element: arrowRef,
            },
          },
        },
      }}
      {...props}
      title={
        <>
          {props.title}
          {isArrowShown && <span className={arrow} ref={setArrowRef} />}
        </>
      }
    />
  )
}

CustomTooltip.defaultProps = {
  isArrowShown: false,
}

CustomTooltip.propTypes = {
  isArrowShown: PropTypes.bool,
  title: PropTypes.node,
}

export default CustomTooltip
